import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Button} from './models/button.model';
import {ToolbarEventModel} from './models/toolbarEvent.model';
import {IToolbarEvent} from './interface/IToolbarEvent';
import {FileManagerConfiguration} from '../configuration/fileManagerConfiguration.service';
import {FileManagerUploader} from '../filesList/fileManagerUploader.service';
import {Store} from '@ngrx/store';
import {IFileManagerState} from '../store/file-manager.reducer';
import {UploadFilesAction, UploadFilesErrorAction} from '../store/file-manager.action';
import {Constants} from "../../../helpers/constants";

@Component({
    standalone: false,
  selector: 'ri-toolbar',
  styleUrls: ['./toolbar.less'],
  templateUrl: './toolbar.html'
})

export class ToolbarComponent implements OnChanges, OnInit {
  @Input() currentFolderId: string;

  @Output() onAddFolderClick = new EventEmitter();
  @Output() onUpload = new EventEmitter();
  @Output() onMenuButtonClick = new EventEmitter();
  @Output() onModeChange = new EventEmitter();


  public constructor(public configuration: FileManagerConfiguration,
                     public fileManagerUploader: FileManagerUploader,
                     public store: Store<IFileManagerState>) {

    this.fileManagerUploader.clear();

    this.fileManagerUploader.uploader.onCompleteAll = () => {
      this.onUpload.emit(this.currentFolderId || '');
    };

    this.fileManagerUploader.uploader.onCompleteItem = (item: any, response: any, status: number, headers: any) => {

		//console.log('status');
		//console.log(status);
      if (status === 200) {
        this.store.dispatch(new UploadFilesAction({files: JSON.parse(response)}));
      } else {
        this.store.dispatch(new UploadFilesErrorAction({files: JSON.parse(response)}));
      }
    };
  }

  ngOnInit(){

    //TODO: Remove HACK!!!
    //console.log('this.fileManagerUploader.uploader.options.url');
    this.fileManagerUploader.uploader.options.url = (window.location.origin || Constants.DefaultApiHost) + '/api/documents/filesAll';
  }

  public getTenantName(): string {
    // create authorization header with jwt token
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if (currentUser != null) {
        return currentUser.tenantName;
        }

        return "";
}


  public ngOnChanges() {
    this.fileManagerUploader.setDirectoryId(this.currentFolderId || '');
  }

  public addFolder() {
    let event: IToolbarEvent = new ToolbarEventModel(Button.ADD_FOLDER, 'New folder');
    this.onAddFolderClick.emit(event);
  }

  public onRefreshFilesList() {
    let event: IToolbarEvent = new ToolbarEventModel(Button.REFRESH_FILES_LIST);
    this.onMenuButtonClick.emit(event);
  }

  public onDownloadZip() {
    let event: IToolbarEvent = new ToolbarEventModel(Button.DOWNLOAD_AS_ZIP);
    this.onMenuButtonClick.emit(event);
  }

  public modeChange(value)
  {
    let event: IToolbarEvent = new ToolbarEventModel(Button.MODE, value);
    this.onModeChange.emit(event);
  }
}
